import { CriteriaModifierType } from 'api-models'
import { LevelType } from 'layout/navbar/breadcrumbs/types'
import { ADDITIONAL_CRITERIA_OPTIONS } from '../../constants'
import { RuleFormType } from '../rule-form/types'

export const buildScopeLevelText = (level: LevelType, platform?: string) => {
	if (level === 'website') return 'website'
	if (level === 'campaign') return 'campaign'

	if (platform === 'GADS') return 'Google Ads account'
	return 'Meta Ads account'
}

export const buildPrefix = (type: CriteriaModifierType, negative?: boolean) => {
	if (
		type === CriteriaModifierType.TIME ||
		type === CriteriaModifierType.PAGE_VIEWS
	) {
		if (negative) return ' less than '
		return ' more than '
	}

	if (negative) return ' is not '
	return ' is '
}

export const isModifierPresent = (
	modifiers: RuleFormType['modifiers'],
	type: CriteriaModifierType
) => {
	return modifiers.some((m) => m.type === type)
}

const additionalCriteriaTypes = ADDITIONAL_CRITERIA_OPTIONS.map((o) => o.type)

export const shouldAddConjunction = (
	modifiers: RuleFormType['modifiers'],
	type: CriteriaModifierType
) => {
	const typeIndex = additionalCriteriaTypes.findIndex((t) => t === type)
	const typesToCheck = additionalCriteriaTypes.slice(0, typeIndex)
	let shouldAppendConjunction = false

	typesToCheck.forEach((typeToCheck) => {
		if (modifiers.some((m) => m.type === typeToCheck)) {
			shouldAppendConjunction = true
			return
		}
	})

	return shouldAppendConjunction
}
